import React from 'react';
import { useFormikContext } from 'formik';
import styles from './ApiForm.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import Select from 'component/atom/forms/select/select/Select';
import HttpBlock from './http-block/HttpBlock';

const ApiForm = ({ id }) => {
  const formik = useFormikContext();

  const requestTypeOptions = [
    { label: 'GET', value: 'get' },
    { label: 'POST', value: 'post' },
    { label: 'PUT', value: 'put' },
    { label: 'PATCH', value: 'patch' },
    { label: 'DELETE', value: 'delete' },
  ];

  return (
    <form
      className={styles['message-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['editor-container']}>
        <div className={styles['form-block']}>
          <p className={styles['description']}>
            Connect to external systems or databases to fetch or send data.
          </p>

          <Select
            placeholder='Select Request Type'
            options={requestTypeOptions}
            name='method'
            value={formik.values.method}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.method}
            touched={formik.touched.method}
            classname={styles.select}
          />

          <Input
            placeholder='Request URL'
            label='Enter URL'
            value={formik.values.requestUrl}
            name='requestUrl'
            onChange={(e) => formik.setFieldValue('requestUrl', e.target.value)}
            error={formik.errors.requestUrl}
            touched={formik.touched.requestUrl}
            onBlur={formik.handleBlur}
          />
        </div>

        <HttpBlock
          title='Headers'
          tooltipText='Extra information sent with the API request'
          fieldName='headers'
          keyPlaceholder='Header Name'
          valuePlaceholder='Value'
        />

        <HttpBlock
          title='Parameters'
          tooltipText='Filters or customizes what data the API returns.'
          fieldName='parameters'
          keyPlaceholder='Parameter Name'
          valuePlaceholder='Value'
        />

        <HttpBlock
          title='Capture Response'
          tooltipText='Defines how the returned data will be used or shown.'
          fieldName='captureResponses'
          keyPlaceholder='Key'
          valuePlaceholder='Value'
        />
      </div>
    </form>
  );
};

export default ApiForm;
